export const STATUS_NEW = "new"
export const STATUS_IN_PROGRESS = "in-progress"
export const STATUS_CLOSED = "closed"

export type ConversationStatus =
    "new"
    | "in-progress"
    | "closed"

export const ConversationStatuses = [STATUS_NEW, STATUS_IN_PROGRESS, STATUS_CLOSED]


// WEBPACK FOOTER //
// ./src/state/conversation/ConversationStatuses.ts